module.exports = __webpack_public_path__ + "static/media/brand-img2.36fa15c7.png";